<template>

  <!--红包活动弹窗-->
  <div class="alert-box rob-red-envelopes">
    <p @click="closeFun" class="mask"></p>
    <div class="alert-box-con-red">
      <img @click="closeFun" class="red-envelopes-close" src="../assets/red-envelopes-close.png" />

      <img class="red-envelopes-bg" src="../assets/red-envelopes-bg.png" alt="">
      <img class="mid-festival-icon" src="../assets/mid-festival-icon.png" alt="">
      <img class="red-envelopes-rob" :class="redEnvelopes.takeEnvelope==1?'curr':''" @click="takeEnvelope" src="../assets/red-envelopes-rob.png" alt="">
      <p class="red-envelopes-title">听金牌解说 100%领红包</p>
      <p class="red-envelopes-text">{{ redEnvelopes.desc }}</p>
    </div>
  </div>

</template>

<script>

  import {getCouponAtRandom} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        userInfo: {},
        isSuccess: false, //是否提交
        personEnvelopes: [], //任务红包
      }
    },
    created(){

    },
    props: ['redEnvelopes'],
    computed: {

    },
    methods: {
      //关闭弹窗
      closeFun(){
        this.$emit('close',{redEnvelopes: [], personEnvelopes: [], recommendPerson: ""});
      },

      //抢红包
      async takeEnvelope(){
        this.userInfo = getStore("userInfo");

        if(this.isSuccess){
          return;
        }else {
          this.isSuccess = true;
          this.redEnvelopes.takeEnvelope = 1;

          let that = this;
          getCouponAtRandom(that.redEnvelopes.id,function(res){

            if(res.data.errcode == '00000'){
              console.log(res.data)
              that.personEnvelopes = res.data.data

              setTimeout(function() {
                that.redEnvelopes.takeEnvelope = 0;
                that.$emit('close',{redEnvelopes: [], personEnvelopes: that.personEnvelopes, recommendPerson: ""});
              }, 1200)
            }
          })


        }
      }

    },
  }
</script>

<style scoped>

  @import '../style/alert';

</style>



// WEBPACK FOOTER //
// src/components/AlertRedEnvelope.vue